import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import getGroupBookings from '../getGroupBookings.api';
import Results from './Results';
import SearchFilter, {FilterValues} from './SearchFilter';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

export const GroupBookingListContent = (props: {groupId?: number}) => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const [orderBy] = useState([{column: 'created_at', order: 'DESC'}]);

  const addWhereGroupId = (constraints: WhereConstraints) => {
    const whereConstraints = {...constraints}
    if (props.groupId) {
      whereConstraints.AND = [
        {column: 'group_id', operator: OPERATOR.EQ, value: props.groupId},
      ]
    }

    return whereConstraints;
  }

  const initialFilters: FilterValues = {
    start_date: '',
    end_date: '',
    disabled_true: false,
    disabled_false: true,
  };
  const [filters, setFilters] = useState(initialFilters);

  const applyFilters = (newFilters: FilterValues) => {
    setFilters(newFilters);
    setWhere(getConstraintsFromFilters(newFilters));
  };

  const getConstraintsFromFilters = (newFilters: FilterValues) => {
    let whereConstraints: WhereConstraints = {
      AND: [],
    };

    if (newFilters.start_date) whereConstraints.AND!.push({
      column: 'start_date',
      operator: OPERATOR.GTE,
      value: newFilters.start_date
    });
    if (newFilters.end_date) whereConstraints.AND!.push({
      column: 'end_date',
      operator: OPERATOR.LTE,
      value: newFilters.end_date
    });

    if (newFilters.disabled_true) whereConstraints.AND!.push({column: 'disabled', operator: OPERATOR.EQ, value: true});
    if (newFilters.disabled_false) whereConstraints.AND!.push({
      column: 'disabled',
      operator: OPERATOR.EQ,
      value: false
    });

    whereConstraints = addWhereGroupId(whereConstraints)
    return whereConstraints;
  };

  const [where, setWhere] = useState(getConstraintsFromFilters(initialFilters));
  const groupBookingsData = getGroupBookings(rowsPerPage, page, where, orderBy);

  return (
      <React.Fragment>
        <SearchBar filterContent={
          <SearchFilter filters={filters} initialFilters={initialFilters} applyFilters={applyFilters}/>
        }
        />
        <LoadingOverlay loading={groupBookingsData.loading}>
          {groupBookingsData.data && groupBookingsData.data.groupBookings && groupBookingsData.data.groupBookings.data && (
              <Results
                  className={classes.results}
                  groupBookings={groupBookingsData.data.groupBookings.data}
                  paginatorInfo={groupBookingsData.data.groupBookings.paginatorInfo}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
              />
          )}
        </LoadingOverlay>
      </React.Fragment>
  );
};

const GroupBookingList = () => {
  const classes = useStyles();
  const title = 'Bookings';

  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="groups" title={title}/>
      <GroupBookingListContent/>
    </Page>
  );
};

export default GroupBookingList;
